<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modal"
  (onShown)="shown()" aria-hidden="true" [config]="{ backdrop: 'static' }">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" *ngIf="options">
          {{ (options.entityTypeFullName | localize) + ' (' + options.entityTypeDescription + ')' }}
        </h4>
        <button type="button" class="close" (click)="close()" [attr.aria-label]="l('Close')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="primeng-datatable-container" [busyIf]="dataTableHelper.isLoading">
          <p-table #dataTable (onLazyLoad)="getRecordsIfNeeds($event)" [value]="dataTableHelper.records"
            rows="{{ dataTableHelper.defaultRecordsCountPerPage }}" [lazy]="true">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 80px">{{ 'Actions' | localize }}</th>
                <th>
                  {{ 'Action' | localize }}
                </th>
                <th>
                  {{ 'UserName' | localize }}
                </th>
                <th>
                  {{ 'Date' | localize }}
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-record="$implicit">
              <tr>
                <td>
                  <button class="btn btn-sm btn-primary m-btn m-btn--icon m-btn--icon-only"
                    (click)="showEntityChangeDetails(record)" title="{{ 'Select' | localize }}">
                    <i class="la la-chevron-circle-right"></i>
                  </button>
                </td>
                <td>
                  {{ record.changeTypeName }}
                </td>
                <td>
                  {{ record.userName }}
                </td>
                <td>
                  {{ record.changeTime | momentFormat: 'L LT' }}
                </td>
              </tr>
            </ng-template>
          </p-table>
          <div class="primeng-no-data" *ngIf="dataTableHelper.totalRecordsCount == 0">
            {{ 'NoData' | localize }}
          </div>
          <div class="primeng-paging-container">
            <p-paginator [rows]="dataTableHelper.defaultRecordsCountPerPage" #paginator
              (onPageChange)="getRecordsIfNeeds($event)" [totalRecords]="dataTableHelper.totalRecordsCount"
              [rowsPerPageOptions]="dataTableHelper.predefinedRecordsCountPerPage">
            </p-paginator>
            <span class="total-records-count">
              {{ 'TotalRecordsCount' | localize: dataTableHelper.totalRecordsCount }}
            </span>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-default" (click)="close()">{{ 'Close' | localize }}</button>
      </div>
    </div>
  </div>
</div>
<entityChangeDetailModal #entityChangeDetailModal></entityChangeDetailModal>
